import styled from 'styled-components';

const Form = styled.form`
	margin: 35px auto 25px;
`;

export default Form;
